<div class="row" [@slideIn]="firstColumn" [@slideIn]="secondColumn">
    <div class="{{ columnClasses }}" *ngIf="firstColumn">
        <menu-item-box *ngFor="let item of firstColumn" [menuItem]="item" class="slideIn"></menu-item-box>
    </div>
    <div class="{{ columnClasses }}" *ngIf="secondColumn">
        <menu-item-box *ngFor="let item of secondColumn" [menuItem]="item" class="slideIn"></menu-item-box>
    </div>
</div>
